import axios from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";

export default (auditorId: number, qualificationIds: number[]) =>
  axios.patch(
    `${BackendServices.AUDITOR_SERVICE.AUDITOR}/validateQualifications?auditorId=${auditorId}`,
    qualificationIds
  );
